export default __webpack_public_path__ + "static/media/discord.62f8f233.jpg";